import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/goal/plan/list', params)
    },
    add(params) {
        return post('/admin/goal/plan/add',params)
    }
}